import PropTypes from "prop-types";

const FooterWrapper = ({ className = "" }) => {
  return (
    <div
      className={`flex flex-col items-start justify-start gap-6 max-w-full text-left text-39xl text-base-content/70 font-body-m lg:flex-1 mq750:min-w-full ${className}`}
    >
      <div className="flex flex-row items-start justify-start gap-3.5 text-primary font-heading-1 mq450:flex-wrap">
        <img
          className="h-[65px] w-[62.2px] relative"
          alt=""
          src="/group-39795-2.svg"
        />
        <div className="flex flex-col items-start justify-start pt-[7px] px-0 pb-0">
          <h1 className="m-0 relative text-inherit leading-[58px] font-bold font-[inherit] mq450:text-16xl mq450:leading-[35px] mq1050:text-27xl mq1050:leading-[46px]">
            StockAlgoTrader.
          </h1>
        </div>
      </div>
      <div className="w-[330px] relative text-sm leading-[20px] inline-block max-w-full">
        Maximize your investment in the capital market world with the
        convenience and various features provided by Tradiant.
      </div>
      <div className="flex flex-col items-start justify-start gap-3 text-center text-base">
        <div className="w-[119px] relative leading-[24px] inline-block">
          Unduh Aplikasi
        </div>
        <div className="flex flex-row items-start justify-start gap-3">
          <button className="cursor-pointer [border:none] py-[6.1px] pl-1.5 pr-[11px] bg-black rounded-6xs-1 flex flex-row items-center justify-start gap-[7.6px] hover:bg-darkslategray">
            <img
              className="h-[30.5px] w-[30.5px] relative overflow-hidden shrink-0"
              alt=""
              src="/antdesignapplefilled.svg"
            />
            <div className="relative leading-[18.3px] font-inter text-base-100 text-left">
              <p className="m-0 text-3xs-2">Download on the</p>
              <p className="m-0 text-sm-7">AppStore</p>
            </div>
          </button>
          <button className="cursor-pointer [border:none] py-[6.1px] pl-1.5 pr-[7px] bg-black rounded-6xs-1 flex flex-row items-center justify-start gap-[7.6px] hover:bg-darkslategray">
            <img
              className="h-[30.5px] w-[30.5px] relative overflow-hidden shrink-0"
              alt=""
              src="/logosgoogleplayicon.svg"
            />
            <div className="relative leading-[18.3px] font-inter text-base-100 text-left">
              <p className="m-0 text-3xs-2">GET IT ON</p>
              <p className="m-0 text-sm-7">Google Play</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

FooterWrapper.propTypes = {
  className: PropTypes.string,
};

export default FooterWrapper;
